export default "__VITE_ASSET__CWP9M1NE__"